import { QueryCache } from "react-query";

export const queryCache = new QueryCache();
